import React from 'react'
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode";
import './caretakers-mega-menu-mobile.scss'

const CaretakersMegaMenuMobile = ({ menuOption, setActiveMegaMenuMobile, activeMegaMenuMobile }) => {

    const { homeLink } = useHomeLinkMode();

    const closeOption = () => {
        let subColumn = document.getElementById('subColumn')
        subColumn.classList.add("__close-option")
        setTimeout(function () {
            setActiveMegaMenuMobile(null)
            subColumn.classList.remove("__close-option")
        }, 150)
    }

    return (

        <ul className="f-m-caretakers-mega-menu-mobile__content" id="subColumn">
            <div className="f-m-caretakers-mega-menu-mobile__option" onClick={() => closeOption()}>
                <p >{menuOption.nombreDeLaOpcion}</p>
                <span className="icon-ico-left-arrow "></span>
            </div>
            {menuOption.opcionesSubmenu && menuOption.opcionesSubmenu.map((item, index) => (
                <li key={index}>
                    <a href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + item.redireccionDeLaOpcion}>{item.nombreDeLaOpcion}</a>
                </li>
            ))}
        </ul>
    )
}

export default CaretakersMegaMenuMobile
